
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({})
export default class Hero extends Vue {
  @Prop({})
  backgroundColor?: string;

  @Prop({})
  backgroundImage?: string;

  @Prop({ default: true })
  animated!: boolean;

  @Prop({ default: false })
  hasMask!: boolean;

  get image() {
    return this.backgroundImage && `background-image: url(${this.backgroundImage});`;
  }

  get color() {
    return this.backgroundImage && `background-color: url(${this.backgroundColor});`;
  }
}
